import { render, staticRenderFns } from "./AddLabel.vue?vue&type=template&id=70baf776&scoped=true&"
import script from "./AddLabel.vue?vue&type=script&lang=js&"
export * from "./AddLabel.vue?vue&type=script&lang=js&"
import style0 from "./AddLabel.vue?vue&type=style&index=0&id=70baf776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70baf776",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70baf776')) {
      api.createRecord('70baf776', component.options)
    } else {
      api.reload('70baf776', component.options)
    }
    module.hot.accept("./AddLabel.vue?vue&type=template&id=70baf776&scoped=true&", function () {
      api.rerender('70baf776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/labels/AddLabel.vue"
export default component.exports